import { useRef, useState } from 'react'

const useAddLink = ({ editorRef, onChange }) => {
  const [showLinkPopup, setShowLinkPopup] = useState(false)
  const toolbarRef = useRef(null)

  const openAddLinkPopup = () => {
    const range = editorRef.current.getSelection()

    if (range && range.length > 0) {
      setShowLinkPopup(true)
    }
  }

  const onCloseLinkPopup = () => {
    setShowLinkPopup(false)
  }

  const onAddLink = link => {
    editorRef.current.format('link', link)
    onChange({ html: editorRef.current.root.innerHTML, text: editorRef.current.root.innerText })
  }

  return {
    toolbarRef,
    showLinkPopup,
    openAddLinkPopup,
    onCloseLinkPopup,
    onAddLink,
  }
}

export default useAddLink
